module.exports = __webpack_public_path__ + "img/retrabajos.8bfe9fc6.jpg";